/*
 * create by nguyendx 2017/10/05
 */
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { BrowserModule } from "@angular/platform-browser";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  ConfirmDialogModule,
  GrowlModule,
  TooltipModule,
} from "primeng/primeng";
import { HelperModule } from "../../../../common/helper/helper.module";
import { UploadService } from "../../../../common/services/Upload.service";
import { FlashMessagesModule } from "angular2-flash-messages";
import { TranslateModule } from "@ngx-translate/core";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    ConfirmDialogModule,
    GrowlModule,
    TooltipModule,
    BrowserModule,
    HelperModule,
    FlashMessagesModule,
    TranslateModule,
  ],
  declarations: [],
  exports: [],
  providers: [UploadService],
})
export class StampListModule {}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/stamp_list/stamp.module.ts